import { FormEditor } from './../../models/editors/form-editor.base.model';

export class Tags extends FormEditor<string> {
  controlType = 'tags';
  entities: Array<any>;
  orderable: boolean;
  isSingle?: boolean;

  constructor(options: {} = {}) {
    super(options);
    this.entities = options['entities'] || [];
    this.orderable = options['orderable'] || false;
    this.isSingle = options['isSingle'] || false;
  }
}
